<div class="star" (click)="getFavorite()">
  <fa-icon [icon]="isFavorite? faStar : faStarFull "></fa-icon>
</div>
